import { render, staticRenderFns } from "./EmployeePrint.vue?vue&type=template&id=ed6c64a8&scoped=true"
import script from "./EmployeePrint.vue?vue&type=script&lang=js"
export * from "./EmployeePrint.vue?vue&type=script&lang=js"
import style0 from "./EmployeePrint.vue?vue&type=style&index=0&id=ed6c64a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6c64a8",
  null
  
)

export default component.exports